import { createClient } from '@supabase/supabase-js';
import { siteConfig } from '@/config/site.config';

export const supabase = createClient(
  siteConfig.supabaseUrl,
  siteConfig.supabaseAnonKey
);

export type SupabaseClient = typeof supabase;
